export default "__VITE_ASSET__TNRRT1Ww__"